import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavComponent } from './top-nav/top-nav.component';
import { LeftNavComponent } from './left-nav/left-nav.component';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { LayoutComponent } from './layout/layout/layout.component';
import { SharedModule } from '../shared/shared.module';
import { DrawerComponent } from '../shared/components/drawer/drawer.component';

@NgModule({
  declarations: [TopNavComponent, LeftNavComponent, LayoutComponent],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    SharedModule,
    DrawerComponent,
  ],
  exports: [TopNavComponent, LeftNavComponent, LayoutComponent],
})
export class NavigationModule {}
